import servise from '@/router/axios'

export const fetchDspList = (params) => {
  return servise({
    url: '/report/dsp/list',
    method: 'get',
    params
  })
}

// // 检查DAU
export const dauDspInspect = (params) => {
  return servise({
    url: '/report/dsp/dau/inspect',
    method: 'get',
    params
  })
}
// 主体ID列表
export const getMasterSubjectInfo = (params) => {
  return servise({
    url: '/subjectInfo/get/slot/master/name',
    params
  })
}
